import { CustomSprite } from "../game";

export const preprocessSpriteForAlignment = async (
  spriteUrl: string,
  spriteSize: number,
): Promise<CustomSprite> => {
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return { url: spriteUrl, verticalOffset: 0 };
    }

    const img = new Image();
    img.crossOrigin = "anonymous";

    return new Promise((resolve) => {
      img.onload = () => {
        canvas.width = spriteSize;
        canvas.height = spriteSize;

        ctx.clearRect(0, 0, spriteSize, spriteSize);
        ctx.drawImage(img, 0, 0, spriteSize, spriteSize);

        const imageData = ctx.getImageData(0, 0, spriteSize, spriteSize);
        const pixels = imageData.data;

        let topMostPixel = spriteSize;
        let bottomMostPixel = 0;

        for (let y = 0; y < spriteSize; y++) {
          for (let x = 0; x < spriteSize; x++) {
            const pixelIndex = (y * spriteSize + x) * 4;
            const alpha = pixels[pixelIndex + 3];

            // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
            if (alpha > 0) {
              topMostPixel = Math.min(topMostPixel, y);
              bottomMostPixel = Math.max(bottomMostPixel, y);
            }
          }
        }

        const spriteCenter = spriteSize / 2;
        const visualBottom = bottomMostPixel;
        const physicsRadius = spriteSize / 2;

        const desiredVisualBottom = spriteCenter + physicsRadius;
        const verticalOffset = desiredVisualBottom - visualBottom;

        const dataUrl = canvas.toDataURL("image/png");

        resolve({ url: dataUrl, verticalOffset });
      };

      img.onerror = () => {
        resolve({ url: spriteUrl, verticalOffset: 0 });
      };

      img.src = spriteUrl;
    });
  } catch (error) {
    return { url: spriteUrl, verticalOffset: 0 };
  }
};
